import { signalStore } from '@ngrx/signals';
import { withBase } from './features/base.feature';
import { withResponse } from './features/response.feature';
import { withSearch } from './features/search.feature';

/**
 * Advanced Commerce Search Store
 *
 * @link https://ngrx.io/guide/signals/signal-store
 *
 * !!! WARNING: ORDER OF FEATURES IS IMPORTANT - next future can read data from previous, but previous can't read data from next
 */
export const AdvancedCommerceSearchStore = signalStore(
    {
        providedIn: 'root'
    },
    withBase(),
    withResponse(),
    withSearch()
);
